import './App.css';
import { MainRoutes } from './Components/MainRoutes';
import { Navbar } from './Components/Navbar';

function App() {


  return (
    <div className="App">
    
         <Navbar />
         <MainRoutes />

    </div>
  );
}

export default App;
